export default "__VITE_PUBLIC_ASSET__8fd27979__"